/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in page dashboard
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – nanmnth@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import repository from './repository';

const dataInit = {
    area_cd: '01',
    area_name: '東日本統括部',
    customer_cd_from: '',
    customer_cd_to: '',
    customer_name: '',
    branch_cd_from: '',
    branch_cd_to: '',
    branch_name: '',
    address: '',
    representative: '',
    pageSize: 10,
    pageNo: 1,
    col: '',
    sort: ''
};
export default {
    namespaced: true,
    state: {
        isSuccess: false,
        data: { ...dataInit },
        selectOptionKey: ['id', 'content'],
        totalRows: 0,
        listData: [],
        data_select: {
            listSituation: [
                {
                    id: 0,
                    content: '状態1'
                },
                {
                    id: 1,
                    content: '状態2'
                }
            ]
        },
        msgNoData: '該当するデータが存在しません。'
    },
    mutations: {
        resetDataInit(state) {
            state.data = { ...dataInit };
            state.listData = [];
            state.totalRows = 0;
            state.msgNoData = '該当するデータが存在しません。';
        },
        setListData(state, data) {
            state.listData = data ?? [];
            state.msgNoData = '';
        },
        setMessage(state, data) {
            state.msgNoData = data;
        },
        setTotalRows(state, data) {
            state.totalRows = data;
        },
        setPageNavigation(state, data) {
            state.data.pageNo = data.currentPage;
            state.data.pageSize = data.perPage;
        },
        setPageNo(state, data) {
            state.data.pageNo = data;
        }
    },
    actions: {
        /**
         * get area info
         * -----------------------------------------
         * @author : PhuongDT - 2024/06/21 - create
         * @params :
         * @access : private
         */
        getAreaInfo(context, input) {
            try {
                repository.getAreaInfo(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code == 200) {
                        if (input.callback) {
                            input.callback(data.Data);
                        }
                    } else {
                        if (input.onError) {
                            input.onError(data.Data.message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        },
        /**
         * action search
         * -----------------------------------------
         * @author : PhuongDT - 2024/06/21 - create
         * @params :
         * @access : private
         */
        searchItem(context, search) {
            try {
                repository.searchItem(search.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        const listData = data.Data.data;
                        if (listData.length > 0) {
                            context.commit('setListData', listData);
                        } else {
                            context.commit('setListData', []);
                            context.commit('setMessage', '該当するデータが存在しません。');
                        }
                        context.commit('setTotalRows', parseInt(data.Data.paging.total_rows));
                        if (search.callback) {
                            search.callback(data);
                        }
                    } else {
                        if (search.onError) {
                            search.onError(data);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        }
    }
};
